import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../auth";

const NAV = [
  ["Overview", "/app"],
  ["Website", "/app/website"],
  ["Services", "/app/services"],
  ["Bookings", "/app/bookings"],
  ["Clients", "/app/clients"],
  ["Settings", "/app/settings"],
  ["AI Assistant", "/app/ai"],
  ["Data Ownership", "/app/data"],
  ["Onboarding", "/app/onboarding"],
] as const;

export function OwnerShell() {
  const { ready, token, business, logout } = useAuth();

  if (!ready) {
    return (
      <main className="auth-layout">
        <p className="notice" style={{ color: "#ecfdf5" }}>
          Loading your workspace...
        </p>
      </main>
    );
  }

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="owner-shell">
      <aside className="owner-nav">
        <div>
          <div className="brand-mark">
            DUTS <span>Business</span>
          </div>
          <p className="notice" style={{ color: "rgba(236,253,245,0.7)" }}>
            {business?.name ?? "Your business"}
          </p>
        </div>
        <nav>
          {NAV.map(([label, path]) => (
            <NavLink key={path} to={path} end={path === "/app"}>
              {label}
            </NavLink>
          ))}
        </nav>
        <button className="btn btn-secondary" type="button" onClick={logout}>
          Sign out
        </button>
      </aside>
      <div className="owner-content">
        <Outlet />
      </div>
    </div>
  );
}
